import React from 'react';
import { ListRenderItem } from 'react-native';

import PostCard from '@src/components/PostCard';
import RefreshControl from '@src/components/RefreshControl';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import useViewableItems from '@src/hooks/useViewableItems';
import { Post } from '@src/types';

import EmptyPosts from './EmptyPosts';
import { FriendsJourneys } from './FriendsJourneys';
import { FriendsSuggestion } from './FriendsSuggestion';
import { Container, PostList } from './styled';
import { Props } from './types';
import useFriendsPosts from './useFriendsPosts';

const Screen: React.FC<Props> = () => {
  const posts = useFriendsPosts();
  const {
    handleViewableItemsChanged,
    currentVisibleIndex,
    viewabilityConfig,
  } = useViewableItems();
  const handleScroll = useAnimatedHeader();

  const renderPostItem: ListRenderItem<Post> = React.useCallback(
    ({ item, index }) => {
      if (index === 3) {
        return (
          <>
            <PostCard data={item} play={index === currentVisibleIndex} />
            <FriendsSuggestion />
          </>
        );
      }
      return <PostCard data={item} play={index === currentVisibleIndex} />;
    },
    [currentVisibleIndex]
  );

  return (
    <Container>
      <PostList
        data={posts.data}
        refreshControl={
          <RefreshControl
            refreshing={posts.refreshing}
            onRefresh={posts.handleRefresh}
          />
        }
        ListHeaderComponent={<FriendsJourneys />}
        onViewableItemsChanged={handleViewableItemsChanged}
        viewabilityConfig={viewabilityConfig}
        onEndReached={posts.handleEndReached}
        onScroll={handleScroll}
        renderItem={renderPostItem}
        ListEmptyComponent={
          <EmptyPosts loading={posts.loading || posts.refreshing} />
        }
      />
    </Container>
  );
};

Screen.displayName = 'Activities';

export default Screen;
